import { combineReducers } from 'redux';

import uploadsReducer from './uploads';

export default combineReducers({
  uploads: uploadsReducer,
});
